<div
  class="filter-sort-form"
  *ngIf="
    textFieldModel &&
    textFieldModel.filterBy &&
    dropdownModel &&
    dropdownModel.filterBy
  "
>
  <div class="tags-filter-container d-flex align-items-end flex-wrap">
    <rr-dropdown-field
      name="dropdown2"
      [(ngModel)]="dropdownModel.filterBy.value"
      [settings]="dropDownSettings"
      [options]="options"
      [optionsTemplate]="tagsOptionTemplate"
      sort="none"
      (valueChanged)="changeSelectedFilter($event)"
      (clearInput)="onClearInput($event)"
      readonly
    >
    </rr-dropdown-field>
    <rr-text-field
      [(ngModel)]="textFieldModel.filterBy.value"
      [settings]="textFieldSettings"
      [minlength]="1"
      (change)="changeInputFilter()"
      (clearInput)="setTextInputDefaultValues()"
      (input)="changeInputFilter()"
    >
    </rr-text-field>
    <button
      class="add-tag-filter-btn btn btn-outline-dark btn-sm"
      [disabled]="!isTagValid"
      (click)="addTagToFilter()"
    >
      +
    </button>
  </div>
  <div>
    <rr-tags
      [tags]="displayTags"
      [showRemoveButton]="true"
      (removeClicked)="removeTagFromFilter($event)"
    ></rr-tags>
  </div>
</div>

<ng-template #tagsOptionTemplate let-item="item">
  <span>
    <span class="oi oi-tag" [ngStyle]="{ color: getTagColor(item.id) }"></span>
    &nbsp;
    <span>{{ item.value }}</span>
  </span>
</ng-template>
